import { Component, Injector, Optional } from '@angular/core';
import { ClienteUnicoDto, ClienteUnicoServiceProxy, OrderDto, OrdersServiceProxy } from '../services/service-proxy/service-proxies';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, tap } from 'rxjs';
import { AppService } from '../services/app.service';


@Component({
  selector: 'app-order-list',
  templateUrl: './orders-list.component.html',
  styleUrls: ['./orders-list.component.scss']
})
export class OrdersListComponent {

  isLoading = false;
  orders? : OrderDto[];
  idUnico;
  countryCode;

  pageIndex = 0;
  totalPages = 0;
  totalInvoices = 0;

  constructor(public appService : AppService,
              private orderService: OrdersServiceProxy) {

                this.idUnico = appService.idUnico;
                this.countryCode = appService.countryCode;
                this.orders = [];
  }

  ngOnInit() {

    const paging = this.appService.getOrdersPaging();

    if(paging){
      this.totalPages = paging.totalPages;
      this.totalInvoices = paging.totalInvoices;
      this.cargarPagina(paging.pageIndex);
    } else {
      this.cargarPagina(0);
    }
  }

  cargarPagina(pageIndex : number) {

    if(pageIndex < 0 || this.isLoading)
      return;

    const cached = this.appService.getOrdersData(pageIndex);

    if(cached){
      this.orders = cached;
      this.pageIndex = pageIndex;
      this.guardarPaginado();
      return;
    }

    this.isLoading = true;

    // dias y pageSize van en null a proposito: los define el backend (400 dias y 5
    // facturas por pagina, con tope duro). Asi el limite vive en un solo lugar.
    this.orderService
      .getOrders(this.idUnico, null, this.countryCode, null, null, pageIndex, null)
      .pipe(finalize( () => this.isLoading = false))
      .subscribe( (response) => {

          this.orders = response.items ?? [];
          this.pageIndex = response.pageIndex ?? pageIndex;
          this.totalPages = response.totalPages ?? 0;
          this.totalInvoices = response.totalInvoices ?? 0;

          this.appService.saveOrdersData(this.orders, this.pageIndex);
          this.guardarPaginado();
      });
  }

  verMas() {
    this.cargarPagina(this.pageIndex + 1);
  }

  verAnterior() {
    this.cargarPagina(this.pageIndex - 1);
  }

  get hayPaginaSiguiente() : boolean {
    return this.pageIndex + 1 < this.totalPages;
  }

  get hayPaginaAnterior() : boolean {
    return this.pageIndex > 0;
  }

  get mostrarPaginado() : boolean {
    return !this.isLoading && (this.hayPaginaAnterior || this.hayPaginaSiguiente);
  }

  private guardarPaginado() {
    this.appService.saveOrdersPaging({
      pageIndex : this.pageIndex,
      totalPages : this.totalPages,
      totalInvoices : this.totalInvoices
    });
  }
}
